module.exports = __webpack_public_path__ + "img/banner-cd.1ec50498.jpeg";